import { createCookieBanner } from '@lst/cookie-banner';

if (!/MKclient\/1\.0/i.test(window.navigator && window.navigator.userAgent)) {
  createCookieBanner({
    openPolicyInNewTab: true,
  });
}
